
import { endpoints } from '../../functions/shared/api/apiConfig'
import { apiFetch } from '../../functions/shared/api/client'
import { ACCESS_KEY, urlAPI, urlAPIv2 } from '../../urls'
import type { RunRecord } from './safeTypes'

const HISTORY_FIELD = 'EventsRunsHistory'

type HistoryResponse = {
    ok: boolean
    history: RunRecord[]
    configId?: number
    error?: string
}

const normalizeHistory = (history: RunRecord[] | undefined | null): RunRecord[] => {
    if (!Array.isArray(history)) return []
    return history.filter(Boolean).slice(0, 50)
}
export const updateEventsRunsHistory = async (history: RunRecord[], configId: number): Promise<HistoryResponse> => {
  const trimmed = normalizeHistory(history)

  if (!configId) {
    return { ok: false, history: trimmed, error: 'configId is missing' }
  }

 
  const payload = {
    method: 'PUT',
    collection: 'config',
    body: {
      data: {
        [HISTORY_FIELD]: trimmed,
      },
    },
  }

  try {
    await apiRequest(payload)
    return { ok: true, history: trimmed }
  } catch (e: any) {
    return { ok: false, history: trimmed, error: e?.message ?? 'Failed to update history' }
  }
}
const apiRequest = async (payload: any): Promise<any> => {
  const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''


  const method = String(payload?.method ?? 'GET').toUpperCase()
  const collection = String(payload?.collection ?? '').replace(/^\/+/, '')
  const bodyObj = payload?.body ?? null

  const url = `${urlAPIv2}/${collection}`

  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
    body: bodyObj != null ? JSON.stringify(bodyObj) : undefined,
  })

  const text = await res.text()
  console.log(text, 'text')

  let json: any = null
  try {
    json = text ? JSON.parse(text) : null
  } catch {
    throw new Error(`Non-JSON response (${res.status}): ${text}`)
  }

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}: ${JSON.stringify(json)}`)
  }

  return { success: true, response: json }
}
// export const updateEventsRunsHistory = async (history: RunRecord[], configId: number): Promise<HistoryResponse> => {
//   const trimmed = normalizeHistory(history)

//   if (!configId) {
//     return { ok: false, history: trimmed, error: 'configId is missing' }
//   }

//   const payload = {
//     method: 'PUT',
//     collection: 'config',
//     body: {
//         [HISTORY_FIELD]: trimmed,
     
//     },
//   }

//   try {
//     await apiRequest(payload)
//     return { ok: true, history: trimmed }
//   } catch (e: any) {
//     return { ok: false, history: trimmed, error: e?.message ?? 'Failed to update history' }
//   }
// }


// const apiRequest = async (payload: any): Promise<any> => {
//   const res = await fetch(urlAPI, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       Authorization: `Bearer ${window.localStorage.getItem(ACCESS_KEY) ?? ''}`,
//     },
//     body: JSON.stringify(payload),
//   })

//   const text = await res.text()
//  console.log(text,"text")
//   let json: any = null
//   try {
//     json = text ? JSON.parse(text) : null
//   } catch {
//     throw new Error(`Non-JSON response (${res.status}): ${text}`)
//   }


//   if (!res.ok) {
//     throw new Error(`HTTP ${res.status}: ${JSON.stringify(json)}`)
//   }

//   if (!json?.success) {
//     throw new Error(JSON.stringify(json))
//   }

//   if (json?.response?.error) {
//     throw new Error(JSON.stringify(json.response.error))
//   }

//   return json.response
// }
